import { useState, useCallback } from "react";
import { FlashbarProps } from "@amzn/awsui-components-react/polaris/flashbar";

interface LocalNotification extends FlashbarProps.MessageDefinition {
  timeout?: number;
}

export const useLocalNotifications = () => {
  const [notifications, setNotifications] = useState<
    FlashbarProps.MessageDefinition[]
  >([]);

  const dismissNotification = useCallback((id: string) => {
    setNotifications((prev) =>
      prev.filter((notification) => notification.id !== id)
    );
  }, []);

  const addNotification = useCallback(
    (notification: LocalNotification) => {
      const id = Date.now().toString();
      const newNotification = { ...notification, id };
      setNotifications((prev) => [...prev, newNotification]);

      // Auto-dismiss after timeout
      if (notification.timeout) {
        setTimeout(() => {
          dismissNotification(id);
        }, notification.timeout);
      }
    },
    [dismissNotification]
  );

  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  return {
    notifications,
    addNotification,
    dismissNotification,
    clearNotifications,
  };
};
